module.exports = __webpack_public_path__ + "static/media/pagination-last-disabled.e19696f8.svg";